<template>
  <div class="image-show-wrapper" :class="{ fullscreen: fullscreen }">
    <img :src="imageUrl" :alt="mediaFilename" />
    <div class="mc-notification-media__action" @click.stop>
      <div class="d-flex gap-4 align-items-center">
        <span @click="handleClickDownload()">
          <i class="mc-fa icon-outline_download"></i> {{ $t('global.action.download') }}
        </span>
      </div>
      <span @click="clickFullscreen()">
        <i v-if="!fullscreen" class="mc-fa icon-fill_fullscreen"></i>
        <i v-else class="mc-fa icon-fill_exit-fullscreen"></i>
      </span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    imageUrl: { type: String, required: true },
    mediaFilename: { type: String, required: true },
  },
  data() {
    return {
      fullscreen: false,
    }
  },
  methods: {
    async clickFullscreen() {
      this.fullscreen = !this.fullscreen
      await this.$nextTick()

      if (this.fullscreen) {
        var elem = document.documentElement

        if (elem.requestFullscreen) {
          elem.requestFullscreen()
        } else if (elem.webkitRequestFullscreen) {
          /* Safari */
          elem.webkitRequestFullscreen()
        } else if (elem.msRequestFullscreen) {
          /* IE11 */
          elem.msRequestFullscreen()
        }
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.webkitExitFullscreen) {
          /* Safari */
          document.webkitExitFullscreen()
        } else if (document.msExitFullscreen) {
          /* IE11 */
          document.msExitFullscreen()
        }
      }
    },
    handleClickDownload() {
      if (this.imageUrl) {
        const link = document.createElement('a')
        link.href = this.imageUrl
        link.setAttribute('download', `${this.mediaFilename}`)
        link.click()
        link.remove()
      }
    },
  },
}
</script>
